/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalAuthSubmissionLeadWaitlistDetails } from './PalAuthSubmissionLeadWaitlistDetails';
import {
    PalAuthSubmissionLeadWaitlistDetailsFromJSON,
    PalAuthSubmissionLeadWaitlistDetailsFromJSONTyped,
    PalAuthSubmissionLeadWaitlistDetailsToJSON,
    PalAuthSubmissionLeadWaitlistDetailsToJSONTyped,
} from './PalAuthSubmissionLeadWaitlistDetails';
import type { PalAuthSubmissionLeadWaitlistUpdatesInner } from './PalAuthSubmissionLeadWaitlistUpdatesInner';
import {
    PalAuthSubmissionLeadWaitlistUpdatesInnerFromJSON,
    PalAuthSubmissionLeadWaitlistUpdatesInnerFromJSONTyped,
    PalAuthSubmissionLeadWaitlistUpdatesInnerToJSON,
    PalAuthSubmissionLeadWaitlistUpdatesInnerToJSONTyped,
} from './PalAuthSubmissionLeadWaitlistUpdatesInner';
import type { PalAuthSubmissionStatusUpdatedByUser } from './PalAuthSubmissionStatusUpdatedByUser';
import {
    PalAuthSubmissionStatusUpdatedByUserFromJSON,
    PalAuthSubmissionStatusUpdatedByUserFromJSONTyped,
    PalAuthSubmissionStatusUpdatedByUserToJSON,
    PalAuthSubmissionStatusUpdatedByUserToJSONTyped,
} from './PalAuthSubmissionStatusUpdatedByUser';

/**
 * 
 * @export
 * @interface PalAuthSubmissionLeadWaitlist
 */
export interface PalAuthSubmissionLeadWaitlist {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    lead_id?: string;
    /**
     * 
     */
    status?: PalAuthSubmissionLeadWaitlistStatusEnum;
    /**
     * 
     */
    details?: PalAuthSubmissionLeadWaitlistDetails;
    /**
     * 
     */
    rank?: number;
    /**
     * 
     */
    created_at?: string;
    /**
     * 
     */
    status_set_by_user?: PalAuthSubmissionStatusUpdatedByUser;
    /**
     * 
     */
    receipt_id?: string;
    /**
     * 
     */
    updates?: Array<PalAuthSubmissionLeadWaitlistUpdatesInner>;
}


/**
 * @export
 */
export const PalAuthSubmissionLeadWaitlistStatusEnum = {
    Waitlisted: 'Waitlisted',
    Cleared: 'Cleared',
    Cancelled: 'Cancelled',
} as const;
export type PalAuthSubmissionLeadWaitlistStatusEnum = typeof PalAuthSubmissionLeadWaitlistStatusEnum[keyof typeof PalAuthSubmissionLeadWaitlistStatusEnum];


/**
 * Check if a given object implements the PalAuthSubmissionLeadWaitlist interface.
 */
export function instanceOfPalAuthSubmissionLeadWaitlist(value: object): value is PalAuthSubmissionLeadWaitlist {
    return true;
}

export function PalAuthSubmissionLeadWaitlistFromJSON(json: any): PalAuthSubmissionLeadWaitlist {
    return PalAuthSubmissionLeadWaitlistFromJSONTyped(json, false);
}

export function PalAuthSubmissionLeadWaitlistFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionLeadWaitlist {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
        'status': json['status'] == null ? undefined : json['status'],
        'details': json['details'] == null ? undefined : PalAuthSubmissionLeadWaitlistDetailsFromJSON(json['details']),
        'rank': json['rank'] == null ? undefined : json['rank'],
        'created_at': json['created_at'] == null ? undefined : json['created_at'],
        'status_set_by_user': json['status_set_by_user'] == null ? undefined : PalAuthSubmissionStatusUpdatedByUserFromJSON(json['status_set_by_user']),
        'receipt_id': json['receipt_id'] == null ? undefined : json['receipt_id'],
        'updates': json['updates'] == null ? undefined : ((json['updates'] as Array<any>).map(PalAuthSubmissionLeadWaitlistUpdatesInnerFromJSON)),
    };
}

export function PalAuthSubmissionLeadWaitlistToJSON(json: any): PalAuthSubmissionLeadWaitlist {
    return PalAuthSubmissionLeadWaitlistToJSONTyped(json, false);
}

export function PalAuthSubmissionLeadWaitlistToJSONTyped(value?: PalAuthSubmissionLeadWaitlist | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'status': value['status'],
        'details': PalAuthSubmissionLeadWaitlistDetailsToJSON(value['details']),
        'rank': value['rank'],
        'created_at': value['created_at'],
        'status_set_by_user': PalAuthSubmissionStatusUpdatedByUserToJSON(value['status_set_by_user']),
        'receipt_id': value['receipt_id'],
        'updates': value['updates'] == null ? undefined : ((value['updates'] as Array<any>).map(PalAuthSubmissionLeadWaitlistUpdatesInnerToJSON)),
    };
}

